import { warningColor } from "assets/jss/material-dashboard-react";
import { dangerColor } from "assets/jss/material-dashboard-react";

const coloresEstado = {
  PENDIENTE: warningColor[0],
  RECHAZADO: dangerColor[0],
  CANCELADO: dangerColor[0],
};
export const SET_COLOR_ESTADO = (color) => coloresEstado[color] || "#00C5B4";
